import { IFinanceOptionData } from "common/records/FinanceOption";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_FINANCE_OPTIONS = "@financeOptions/RECEIVE_FINANCE_OPTIONS";
export const RECEIVE_FINANCE_OPTION = "@financeOptions/RECEIVE_FINANCE_OPTION";
export const REMOVE_FINANCE_OPTION = "@financeOptions/REMOVE_FINANCE_OPTION";
export const RESET_FINANCE_OPTION = "@financeOptions/RESET_FINANCE_OPTION";
export const SET_FINANCE_OPTIONS_LOADED_FOR_ORG_ID = "@financeOptions/SET_FINANCE_OPTIONS_LOADED_FOR_ORG_ID";

export const FinanceOptionActions = {
  receiveFinanceOption: (financeOption: Partial<IFinanceOptionData>) =>
    createAction(RECEIVE_FINANCE_OPTION, financeOption),
  receiveFinanceOptions: (financeOptions: Partial<IFinanceOptionData>[]) =>
    createAction(RECEIVE_FINANCE_OPTIONS, { financeOptions: financeOptions }),
  removeFinanceOption: (financeOptionId: number) => createAction(REMOVE_FINANCE_OPTION, financeOptionId),
  resetFinanceOption: (financeOptionId: number) => createAction(RESET_FINANCE_OPTION, financeOptionId),
  setLoadedForOrgId: (orgId: number) => createAction(SET_FINANCE_OPTIONS_LOADED_FOR_ORG_ID, orgId),
};

export type FinanceOptionActions = ActionsUnion<typeof FinanceOptionActions>;
